/**
 * Reads `#search-app` data attributes (set in the Shopify theme).
 * Mirrors defaults in `api.ts`: missing or unknown `data-page` → search endpoint.
 */
export function getSearchspringDomPageType() {
    if (typeof document === 'undefined')
        return 'search_page';
    const el = document.querySelector('#search-app');
    return (el === null || el === void 0 ? void 0 : el.dataset.page) === 'collection_page' ? 'collection_page' : 'search_page';
}
